<script setup lang="ts">
import type { DataTableHeaders } from '@/plugins/vuetify';
import type { HistoriqueChangement } from '@/utils/historique'
import { toDate_wd_dd_MMMM_yyyy_hh_mm_ss } from '@/utils/helpers'
import type MDBVegcoBucket from '@/types/vegco/bucket'
import { getBucketHistoriqueChangements } from '@/utils/historique'

//const storeU = useUtilisateurStore()
const dialog = ref(false)
const isLoading = ref(true)
const historique = ref([] as HistoriqueChangement[])
const headers: DataTableHeaders = [
  { title: 'Modifié par', key: 'modifiéPar', width: '130px'},
  { title: 'Date modification', key: 'formattedDateModification', width: '160px' },
  { title: 'Résumé', key: 'résumé'}
];
const formattedHistorique = computed(() => {
  return historique.value.map(h => ({
    ...h,
    formattedDateModification: toDate_wd_dd_MMMM_yyyy_hh_mm_ss(h.dateModification)
  }));
});

function openHist(changements: HistoriqueChangement[]) {
  historique.value = changements
  dialog.value = true
  isLoading.value = false
}

async function openHistAsync(changements: () => Promise<HistoriqueChangement[]>) {
  historique.value = []
  dialog.value = true
  isLoading.value = true
  try {
    historique.value = await changements();
  }
  catch (e) {
    Notify.error(e)
    dialog.value = false
  }
  finally {
    isLoading.value = false
  }
}

async function openHistBucketAsync(bucket: MDBVegcoBucket) {
  await openHistAsync(async () => {
    const historique = [ bucket ] as MDBVegcoBucket[]
    const resultHistorique = await apiProphet.get(`vgco/buckets/${bucket.id}/historique`)
    historique.push(...(resultHistorique.data as MDBVegcoBucket[]))
    return getBucketHistoriqueChangements(historique)
  })
}

defineExpose({ openHist, openHistAsync, openHistBucketAsync })
</script>

<template>
  <v-dialog v-model="dialog" max-width="90%" :fullscreen="$vuetify.display.smAndDown">
    <v-card style="z-index: -1">
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="text-h5 text-medium-emphasis ps-2">Historique</span>
        <v-btn icon="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" variant="text" @click="dialog = false"/>
      </v-card-title>

      <v-divider class="mb-4"/>

      <v-card-text>
        <v-data-table
          :headers="headers" :items="formattedHistorique" :loading="isLoading"
          :hide-default-header="$vuetify.display.smAndDown" :items-per-page="-1">
          <template v-if="$vuetify.display.smAndDown" #item="props">
            <tr>
              <td class="pt-2 pb-2">
                Par: {{ props.item.modifiéPar }}<br/>
                Date: {{ props.item.formattedDateModification }}<br/>
                Modifs: {{ props.item.résumé }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>

      <v-divider class="mt-2"/>

      <v-card-actions class="my-2 d-flex justify-end mr-2">
        <v-btn color="primary" variant="flat" @click="dialog = false">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
